import { useFlysiteUrls } from 'hooks/useFlysiteUrls/useFlysiteUrls';
import defaultLogo from './defaultLogo.svg';
import './Powered.scss';

export const Powered = () => {
  const { flysiteUrl } = useFlysiteUrls();

  return (
    <div className="Powered">
      <a
        href={flysiteUrl}
        rel="noopener noreferrer"
        target="_blank"
        className="flex items-center focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-white rounded p-1"
      >
        <p className="Powered-text">Powered by</p>
        <img className="Powered-logo" src={defaultLogo} alt="Flywire" />
      </a>
    </div>
  );
};
